/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core-internal';
import { dataActionOptions, wrapDataAction } from './wrap-data-action';
/**
 * Higher order function which exposes the current method as an action
 * @param action The action method
 * @param isBatched If the service call can handle batched requests efficiently
 * @param input Optional parameter of a single instance or an array of IActionInputs that will be passed to the action method.
 */
export const createDataAction = <TOut>(options: dataActionOptions<TOut>): IAction<TOut> => {
    return <IAction<TOut>>wrapDataAction<TOut>(
        options,
        (arg1: IActionInput | IActionInput[], arg2: IActionContext): Promise<TOut> => {
            return <Promise<TOut>>arg2.chainAction<TOut>(options.action, arg1);
        }
    );
};
